import { useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import SMSContactAdmin from "./SMSContactAdmin";
import Loading from "./SkyExchangeSrc/src/components/Loading";

import { AsianExchangeRoutes } from "./AsianExchangeSrc/AsianExchangeRoutes";
import { SkyExchnageRoutes } from "./SkyExchangeSrc/src/SkyExchnageRoutes";
import { GugoExchnageRoutes } from "./GugoExchangeSrc/src/GugoExchnageRoutes";

import { selectSiteLayout } from "./AsianExchangeSrc/utils/helper/commonSelectors";
import { getRefreshSitesByDomain, getSitesByDomain } from "./AsianExchangeSrc/api";
import { setSiteDetails } from "./AsianExchangeSrc/redux/slices/siteSlice";
import { AuraExchangeRoutes } from "./AuraExchangeSrc/AuraExchangeRoutes";
import { DiamondExchnageRoutes } from "./DaimondExchnageSrc/DiamondExchnageRoutes";

const App = () => {
  const layout = useSelector(selectSiteLayout());

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
    const domainName = window.location.host;
  const routerMap = {
    asianexchange: AsianExchangeRoutes(),
    skyexchange: SkyExchnageRoutes,
    gugoexchnage: GugoExchnageRoutes,
    auraexchange: AuraExchangeRoutes(),
    diamondexchange: DiamondExchnageRoutes,
  };

  useEffect(() => {
    (async () => {
      try {
        const domainName = window.location.host;
        const response = await getSitesByDomain(domainName);
        const siteDetails = response?.data?.siteDetails;

        if (siteDetails) {
          dispatch(setSiteDetails(siteDetails));
        } else {
          console.warn("No site details found for the current domain.");
        }
      } catch (error) {
        console.error("Failed to fetch site details:", error);
      } finally {
        setLoading(false);
      }
    })();
  }, [dispatch]);

    useEffect(() => {
      (async () => {
        try {
          const response = await getRefreshSitesByDomain(domainName);
          const siteDetails = response?.data?.siteDetails;
        
  
          if (siteDetails) {
            dispatch(setSiteDetails(siteDetails));
          } else {
            console.warn("No site details found for the current domain.");
          }
        } catch (error) {
          console.error("Failed to fetch site details:", error);
        }
      })();
    }, [dispatch]);
  const currentPath = window.location.pathname;
  if (loading && currentPath !== "/score" && currentPath !== "/tv") return <Loading />;
  if (loading && currentPath === "/score") return (<div className="relative w-full bg-[#141435]" style={{ height: "500px" }}>
    {loading && (
      <div className="absolute inset-0 flex justify-center items-center bg-[#141435] z-10">
        <span className="text-white" style={{ marginTop: -300 }}>Loading Score...</span>
      </div>
    )};
  </div>)
  if (loading && currentPath === "/tv") return (<div className="relative w-full aspect-video bg-[#141435]">
    {loading && (
      <div className="absolute inset-0 flex justify-center items-center bg-[#141435] z-10 h-[500px]">
        <span className="text-black" style={{ marginTop: -300 }}>Loading Tv...</span>
      </div>
    )};
  </div>)
  const SelectedRouter = routerMap[layout];

  return SelectedRouter ? (
    <RouterProvider router={SelectedRouter} />
  ) : (
    <SMSContactAdmin />
  );
};

export default App;
